import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackMBlue = ({ state, workState, onLabelClick }) => (
	<g id="TrackMBlue" transform="translate(1502.000000, 917.000000)" className="track">
		<g id="line" transform="translate(0.719060, 8.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M32.5460794,57.7681768 C39.6870042,52.4483633 44.8131645,44.6819528 46.7924722,35.7539063 C49.5289027,23.4107122 59.1899448,13.7835441 71.5426741,11.0904844 L122.413346,1.42108547e-14"/>
			<path d="M0.804249431,71.0177431 C8.39916713,68.2926764 15.1898354,65.7286005 22.7847531,63.0035337"/>

			<TrackArrow transform="translate(20.349015, 63.992951) rotate(-197.000000) translate(-20.349015, -63.992951) "
									points="24.349015 71.992951 16.349015 63.992951 24.349015 55.992951"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackMBlue')}
			coords="65.132406, 0.000000"
			text='M'
			textCoordsX={'11.6953125'}
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

TrackMBlue.propTypes = trackPropTypes;

export default TrackMBlue;
